import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { openModalDebitComp }  from "../../actions";
import { bindActionCreators } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Typography } from '@material-ui/core';
import HeaderAppBar from '../../components/HeaderAppBar';
import HeaderUser from '../../components/HeaderUser';
import Footer from '../../components/Footer';
import ButtonOK from '../../components/ButtonOK';
import imgPessoasSucesso from "../../assets/img/img-pessoas-sucesso.svg";

const styles = (theme) => ({
  background: {
    background: '#c6e5f7',
  },
  container: {
    padding: '20px 15px',
    background: '#c6e5f7',
  },
  gridItem: {
    padding: 15,
    display: 'flex',
    justifyContent: 'center',
    flexDirection: 'column',
  },
  message: {
    width: '100%',
    fontSize: 18,
  },
  button: {
    padding: '7px 30px',
    fontSize: 17,
  },
  imgPessoas: {
    width: '100%',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    }
  }
})

export class DebitCardConfirmation extends Component {
  static propTypes = {
    prop: PropTypes
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={classes.background}>
        <HeaderAppBar />
        <HeaderUser />
        <Grid container className={classes.container}>
          <Grid item xs={12} sm={4} md={5} className={classes.gridItem}>
            <Typography variant="h2" component="h1" color="textSecondary">
              PRONTO!
            </Typography>

            <Typography variant="h5" component="h3" color="textSecondary" className={classes.message}>
              <p>A alteração da opção de pagamento foi concluída e produzirá efeitos a partir do exercício seguinte.</p>
            </Typography>

            <ButtonOK />
          </Grid>

            <Grid item xs={12} sm={8} md={7} className={classes.gridItem}>
              <img
                src={imgPessoasSucesso}
                className={classes.imgPessoas}
                alt="Imagem de Pessoas demonstrando sucesso na operação"
              />
            </Grid>
        </Grid>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = (store) => ({
  openModalDebit: store.cardDebitState.openModalDebitValue,
})

const mapDispatchToProps = dispatch =>
  bindActionCreators({ openModalDebitComp }, dispatch);

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(DebitCardConfirmation)
);